import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Hook to fetch product comparison data when modal opens
 * Handles SKU extraction, validation, and auto-close for single products
 *
 * @param {boolean} isOpen - Whether the comparison modal is open
 * @param {Array} selectedProducts - Array of selected products to compare
 * @param {Function} onFetchComparison - Redux action creator for fetching comparison data
 * @param {Function} onDismiss - Redux action creator to dismiss the modal
 *
 * @example
 * useComparisonFetch(isModalOpen, selectedProducts, fetchComparison, dismissModal);
 */
export const useComparisonFetch = (isOpen, selectedProducts, onFetchComparison, onDismiss) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (isOpen && selectedProducts.length >= 1 && onFetchComparison) {
            // Extract and filter valid SKU IDs
            const skuIds = selectedProducts.filter(p => p?.currentSku?.skuId).map(p => p.currentSku.skuId);

            if (skuIds.length > 0) {
                // Fetch comparison data
                dispatch(onFetchComparison({ skuIds }));

                // Auto-close modal when only one product is selected
                // (can't compare a single product)
                if (selectedProducts.length === 1) {
                    dispatch(onDismiss());
                }
            }
        }
    }, [isOpen, selectedProducts, onFetchComparison, dispatch]);
};

export default useComparisonFetch;
